import * as React from 'react';
import { createPortal } from 'react-dom';
export class Portal extends React.Component {
    constructor(props) {
        super(props);
        this.createPortalDom = () => {
            const dom = document.createElement('div');
            document.body.appendChild(dom);
            return this.setState({ dom });
        };
        this.state = {
            dom: null,
        };
    }
    componentDidMount() {
        if (document) {
            return this.createPortalDom();
        }
        setTimeout(this.componentDidMount, 500);
    }
    componentWillUnmount() {
        this.state.dom.remove();
    }
    render() {
        return (this.state.dom && createPortal(this.props.children, this.state.dom)) || React.createElement("div", null);
    }
}
//# sourceMappingURL=Portal.js.map